export function slugify(text, divider = '-') {
	// Replace non-letter or non-digit characters with the divider
	text = text.replace(/[^\p{L}\d]+/gu, divider);

	// Transliterate (convert accented characters to their ASCII equivalents)
	text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

	// Remove unwanted characters
	text = text.replace(/[^-\w]+/g, '');

	// Trim any leading or trailing dividers
	text = text.trim().replace(/^-+|-+$/g, '');

	// Replace duplicate dividers with a single one
	text = text.replace(/-+/g, divider);

	// Convert to lowercase
	text = text.toLowerCase();

	if (!text) {
		return 'n-a';
	}

	return text;
}